module.exports = __webpack_public_path__ + "img/w4_04.11076e80.jpg";